import { getWorkflowInputs } from '@makemydeal/dr-sales-checkin-utils';
import type { WorkflowInputs } from '@makemydeal/dr-sales-checkin-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

/**
 * The deal signals the workflow rules branch on, read off the store.
 *
 * This is the only place the Redux shape behind those signals is read, and `getWorkflowInputs` is
 * the same adapter the BFF calls — so a rule here and its counterpart in
 * `sales-checkin-bff/src/utils/showroomApplicationState.ts` cannot disagree about what the deal says.
 *
 * Deliberately reads `state` defensively rather than going through `getActiveDeal`: rules run on
 * every action, including before the deal and validation slices have hydrated.
 */
export const getWorkflowInputsFromState = (state: any): WorkflowInputs =>
    getWorkflowInputs(
        state?.salesCheckin?.activeDeal?.details,
        state?.salesCheckin?.dealValidation?.missingFields,
        state?.salesCheckin?.dealValidation?.valid,
        undefined,
        state ? featureToggleSelectors.isAmdPdfWorkflowEnabled(state) : false
    );
